import { css } from '@adornis/chemistry/directives/css.js';
import { XNativeDialog } from '@adornis/dialog/x-native-dialog.js';
import { html } from 'lit';

export const openWarningDialog = async ({
  title,
  message,
  confirmText,
  cancelText,
}: {
  title: string;
  message: string;
  confirmText: string;
  cancelText: string;
}) => {
  const confirmed = await XNativeDialog.showPopup<boolean>({
    modal: true,
    content: resolve => {
      return html`
        <x-flex ${css({ width: '400px', padding: '24px' })}>
          <x-text ${css({ marginBottom: '12px' })}><b>${title}</b></x-text>
          <x-text ${css({ marginBottom: '24px' })}>${message}</x-text>
          <x-flex horizontal crossaxis-center space-between>
            <x-button @click=${() => resolve(false)} mode="outline" ${css({ borderColor: '#000', color: '#000' })}>
              ${cancelText}
            </x-button>
            <x-button tone="error" @click=${() => resolve(true)}><b>${confirmText}</b></x-button>
          </x-flex>
        </x-flex>
      `;
    },
  });
  return confirmed;
};
